import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0ba12f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mx-0 row-cols-1 row-cols-md-2 g-4 gx-md-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("canvas", { id: "product-preview" })
], -1))
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "product-customize" }
const _hoisted_5 = { class: "product-info" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dynamic_form = _resolveComponent("dynamic-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.selectedProduct.name), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.selectedProduct.createdDate), 1)
        ]),
        _createVNode(_component_dynamic_form, {
          class: "mt-4",
          fields: _ctx.fields,
          onTextChange: _ctx.setText,
          onFontChange: _ctx.setFont,
          onImgChange: _ctx.setImg
        }, null, 8, ["fields", "onTextChange", "onFontChange", "onImgChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary rounded-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, " Back ")
    ])
  ]))
}